// THE ONE LIST of certificates the Android app can be signed with. Passkeys only work in the installed app when its signing
// certificate is listed here. Everything else is generated from this list:
//   - public/.well-known/assetlinks.json (written by scripts/android-passkey.mjs on every build:mobile)
//   - ANDROID_APP_ORIGINS in constants/auth.ts (the server accepts these as the app's origin)
//
// Adding a computer you build Android on:   yarn android:passkey:add-this-machine   (then deploy: yarn deploy:mobile + functions auth, auth-light)
// Google Play's key is shown in Play Console (App signing); add it by hand if Google ever changes it.
//
// (Despite the file name, it also holds the iOS identity at the bottom.)
// Keep each entry on one line, with its label in a trailing comment (the script reads this file).
export const ANDROID_SIGNING_SHA256: string[] = [
  'B8:DB:2A:EC:34:A3:64:B4:7E:8C:92:8A:96:65:BC:3D:AC:D9:8D:EB:F3:41:84:8B:7D:5E:A1:5C:4F:E2:73:C6', // debug: Windows PC
  'C1:38:FB:E3:FA:9A:85:77:1D:D3:4B:68:33:68:73:08:4B:93:7C:8F:D4:FC:89:C2:C0:9E:B8:DF:0A:EC:59:96', // Google Play app signing key
];

export const ANDROID_PACKAGE_NAME = 'rsmaidsservice.com';

// iOS passkeys: Apple trusts the app through public/.well-known/apple-app-site-association, generated from these two values
// (Team ID from developer.apple.com > Membership; bundle ID is the one Xcode signs the App target with).
export const IOS_TEAM_ID = 'MDA29UTNR5';
export const IOS_BUNDLE_ID = 'rsmaids.booking';
